/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {EntryMetadata} from "./EntryMetadata";
/**
 * Created by andrea on 2017-06-24.
 */

export class EntryCategory extends EntryMetadata {

  constructor(id: string, name: string, description: string) {
    super(id, name, description);
  }

  static listFromSnapshot(key: string, val: [{name, description}]) {
    let items: Array<EntryCategory> = [];

    for (let id of Object.keys(val)) {
      items.push(new EntryCategory(id, val[id].name, val[id].description));
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/EntryCategory.ts